
import { useTranslation } from 'react-i18next';

export default function Stats() {
  const { t } = useTranslation('home');

  const stats = [
    {
      number: '50+',
      label: t('stats.countriesServed', 'Countries Served'),
      description: t('stats.countriesServedDesc', 'Serving clients across the globe')
    },
    {
      number: '25GW',
      label: t('stats.energyCapacity', 'Energy Capacity'),
      description: t('stats.energyCapacityDesc', 'Managing vast energy infrastructure')
    },
    {
      number: '99.9%',
      label: t('stats.reliabilityRate', 'Reliability Rate'),
      description: t('stats.reliabilityRateDesc', 'Industry-leading uptime and performance')
    },
    {
      number: '500+',
      label: t('stats.enterpriseClients', 'Enterprise Clients'),
      description: t('stats.enterpriseClientsDesc', 'Trusted by leading organizations')
    },
    {
      number: '15+',
      label: t('stats.yearsExperience', 'Years Experience'),
      description: t('stats.yearsExperienceDesc', 'Decades of industry expertise')
    },
    {
      number: '24/7',
      label: t('stats.operationsCenter', 'Operations Center'),
      description: t('stats.operationsCenterDesc', 'Round-the-clock monitoring and support')
    }
  ];

  return (
    <section className="py-20 bg-[#0D1B2A]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4 tracking-tight">
            {t('stats.title', 'Our Impact by the Numbers')}
          </h2>
          <p className="text-xl text-[#C0C0C0] max-w-3xl mx-auto leading-relaxed">
            {t('stats.subtitle', 'Delivering reliable energy solutions worldwide with measurable results')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div 
              key={`${stat.label}-${index}`}
              className="text-center group"
            >
              <div className="bg-[#394B59]/20 rounded-2xl p-8 hover:bg-[#394B59]/30 transition-all duration-300">
                <div className="text-4xl lg:text-5xl font-bold text-white mb-2 font-mono group-hover:text-[#2E8BC0] transition-colors duration-300">
                  {stat.number}
                </div>
                <div className="text-lg font-semibold text-[#2E8BC0] mb-2 uppercase tracking-wide">
                  {stat.label}
                </div>
                <div className="text-[#C0C0C0] text-sm leading-relaxed">
                  {stat.description}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 pt-16 border-t border-[#394B59]">
          <div className="text-center mb-8">
            <h3 className="text-xl font-semibold text-white mb-4">
              {t('stats.certifiedCompliant', 'Certified & Compliant')}
            </h3>
          </div>
          
          <div className="flex flex-wrap justify-center items-center gap-8">
            <div className="flex items-center space-x-3 text-[#C0C0C0]">
              <i className="ri-shield-check-line text-[#2E8BC0] text-2xl"></i>
              <span className="font-medium">ISO 9001:2015</span>
            </div>
            <div className="flex items-center space-x-3 text-[#C0C0C0]">
              <i className="ri-leaf-line text-[#2E8BC0] text-2xl"></i>
              <span className="font-medium">ESG Certified</span>
            </div>
            <div className="flex items-center space-x-3 text-[#C0C0C0]">
              <i className="ri-security-line text-[#2E8BC0] text-2xl"></i>
              <span className="font-medium">SOC 2 Type II</span>
            </div>
            <div className="flex items-center space-x-3 text-[#C0C0C0]">
              <i className="ri-award-line text-[#2E8BC0] text-2xl"></i>
              <span className="font-medium">Energy Star Partner</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
